<!-- 作业备案 -->
<template>
	<div>
		<div class="detail">
			<div class="header">
				<div class="span1">
					<span>作业备案</span>
				</div>
				<div class="right"></div>
			</div>
			<div v-loading="loading">
				<el-form
					ref="form"
					:inline="true"
					:model="form"
					label-width="45px"
					class="flex-center-between"
				>
					<el-form-item label="班级:">
						<el-select
							v-model="form.classId"
							clearable
							placeholder="请选择"
							class="label selectWidth"
						>
							<el-option
								v-for="item in classList"
								:key="item.classId"
								:label="item.className"
								:value="item.classId"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="学科:">
						<el-select v-model="form.subjectId" clearable placeholder="请选择" class="label">
							<el-option
								v-for="item in subjectList"
								:key="item.subjectId"
								:label="item.subjectName"
								:value="item.subjectId"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="教师:">
						<el-select
							v-model="form.teacherId"
							clearable
							filterable
							placeholder="请选择"
							class="label selectWidthTeach"
						>
							<el-option
								v-for="item in teacherList"
								:key="item.teacherId"
								:label="item.teacherName"
								:value="item.teacherId"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="作业日期:" label-width="72px">
						<el-date-picker
							v-model="form.homeworkDate"
							type="date"
							placeholder="请选择"
							class="selectWidthDate"
						>
						</el-date-picker>
					</el-form-item>
					<el-form-item label="审核状态:" label-width="73px">
						<el-select
							v-model="form.stateId"
							clearable
							placeholder="请选择"
							class="label selectWidthCheck"
						>
							<el-option
								v-for="item in stateList"
								:key="item.id"
								:label="item.label"
								:value="item.id"
							>
							</el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="" class="search-btn">
						<el-button type="primary" size="small" @click="searchFun()">查询</el-button>
					</el-form-item>
				</el-form>
				<div class="header-btn">
					<el-button type="primary" size="small" @click="bulkAudit('11')">批量通过</el-button>
					<el-button type="primary" size="small" @click="bulkAudit('2')">批量不通过</el-button>
				</div>

				<div class="table">
					<el-table
						:data="tableData"
						style="width: 100%"
						border
						@selection-change="handleSelectionChange"
					>
						<el-table-column
							type="selection"
							width="25"
							align="left"
							prop="show"
							style="border-right:0"
							class-name="borderCollapse"
							:selectable="selectable"
						>
						</el-table-column>
						<el-table-column prop="className" label="班级" align="left" width="88">
						</el-table-column>
						<el-table-column prop="subjectName" label="学科" align="center" width="80">
						</el-table-column>
						<el-table-column prop="teacherName" label="教师姓名" align="center" width="80">
						</el-table-column>
						<el-table-column prop="homeworkDate" label="作业日期" align="center" width="100">
						</el-table-column>
						<el-table-column prop="content" label="作业内容" align="center" width="140">
							<template slot-scope="scope">
								<div class="hwContent">
									<div v-if="scope.row.whetherResource">
										<img src="../register/img/hw-link.svg" />
									</div>
									<div>
										<el-popover
											placement="bottom"
											width="150"
											:content="scope.row.content"
											popper-class="popper-panel-more-allapp"
											trigger="hover"
											:open-delay="300"
										>
											<span slot="reference" class="show-hover ellipsis-m">
												{{ scope.row.content }}</span
											>
										</el-popover>
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column
							prop="estimateDuration"
							label="预计完成时长"
							align="center"
							width="105"
						>
						</el-table-column>
						<el-table-column prop="status" label="备案状态" align="center" width="80">
							<template slot-scope="scope">
								<p :class="{ green: scope.row.status === '0' }" v-if="scope.row.status === '0'">
									待审核
								</p>
								<p :class="{ blue: scope.row.status === '11' }" v-if="scope.row.status === '11'">
									已备案
								</p>
								<p :class="{ red: scope.row.status === '2' }" v-if="scope.row.status === '2'">
									已驳回
								</p>
							</template>
						</el-table-column>
						<el-table-column prop="createTime" label="登记时间" align="center" width="100">
						</el-table-column>
						<el-table-column header-align="center" align="center" label="操作" fixed="right">
							<template slot-scope="scope">
								<el-button
									type="text"
									size="small"
									@click="check(scope, '11')"
									v-if="scope.row.status === '0'"
									>通过</el-button
								>
								<el-button
									type="text"
									size="small"
									@click="check(scope, '2')"
									v-if="scope.row.status === '0'"
									>不通过</el-button
								>
								<!-- <el-button
									type="text"
									size="small"
									@click="reject(scope.row)"
									v-if="scope.row.status === '11' || scope.row.status === '2'"
									>撤回</el-button
								> -->
								<el-button type="text" size="small" @click="toDetail(scope.row)">查看</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="pagination">
						<!--分页组件-->
						<el-pagination
							background
							:current-page="page.pageNum"
							:page-sizes="[10, 20, 50, 100]"
							:page-size="page.pageSize"
							:total="page.totalPage"
							layout="total,prev, pager, next,jumper,sizes"
							@size-change="sizeChangeHandle"
							@current-change="currentChangeHandle"
						></el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { getRecordList, HwAudit, BatchHwAudit } from "@/api/school/index.js";
	import { getTeacherList } from "@/api/school/schoolChildList.js";
	// import { getUserInfo } from "@/api/user/user.js";
	import dayjs from "dayjs";
	import localForage from "localforage";
	import reqTip from "@/utils/requestTip";

	export default {
		components: {},
		data() {
			return {
				userType: "", //存储的用户角色
				jobType: "", //用户角色
				loading: true,
				classList: [],
				subjectList: [],
				tableData: [], //作业备案列表数据
				form: {
					classId: "",
					subjectId: "",
					teacherId: "",
					homeworkDate: "",
					stateId: "",
				},
				page: {
					pageNum: 1,
					pageSize: 10,
					totalPage: 0,
				},
				stateList: [
					{ id: "0", label: "待审核" },
					{ id: "11", label: "已备案" },
					{ id: "2", label: "已驳回" },
				],
				teacherList: [],
				detail: {
					info: {},
					show: false,
				},
				multipleSelection: [], //多选的数据
			};
		},
		watch: {},
		mounted() {},
		created() {
			this.getCommonList();
			this.fetchTeacherList();
			this.fetchUserInfo();
		},
		activated() {
			this.getDataList();
		},
		methods: {
			async getCommonList() {
				this.classList = await localForage.getItem("classList");
			},
			// 查询用户信息 权限,查询学科组长负责学科
			fetchUserInfo() {
				this.userType = sessionStorage.userType;
				if (this.userType == "G3") {
					this.jobType = "G3"; //管理员
					this.subjectList = this.SubjectList;
				} else if (this.userType == "G1") {
					this.jobType = "G1"; //学科组长
					// 过滤学科组长负责的学科
					let userRole = JSON.parse(sessionStorage.userInfo).user_role;
					userRole = userRole.filter((item) => item.parent_id == "226");
					console.log("userRole--", userRole);
					let powerValue = [];
					userRole.forEach((item) => {
						item._power.forEach((p_item) => {
							p_item.power_value?.forEach((subjectId) => {
								powerValue.push(subjectId);
							});
						});
					});
					console.log("powerValue--", powerValue);
					this.subjectList = this.SubjectList.filter((item) => powerValue.includes(item.subjectId));
				}
			},

			//获取作业备案列表
			async getDataList() {
				this.loading = true;
				let ss = sessionStorage;
				let subjectIdArr = [];
				let subjectId = "";
				this.subjectList.forEach((item) => {
					subjectIdArr.push(item.subjectId);
				});
				subjectId = subjectIdArr.join(",");
				console.log("subjectId--", subjectId);
				let params = {
					loginPlatformCode: ss.loginPlatformCode,
					platformCode: ss.platformCode,
					usessionid: ss.usessionid,
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					teracherId: this.form.teacherId,
					classId: this.form.classId,
					subjectId: this.form.subjectId || subjectId,
					// subjectId: "jcsub01,jcsub02",
					homeworkDate:
						(this.form.homeworkDate && dayjs(this.form.homeworkDate).format("YYYY-MM-DD")) || "",
					auditState: this.form.stateId,
				};
				// console.log("作业备案列表params", params);
				const res = await getRecordList(params);
				this.loading = false;
				console.log("作业备案列表--", res);
				if (!res) return;
				res.list?.forEach((item) => {
					item.homeworkDate = dayjs(item.homeworkDate).format("YYYY-MM-DD");
					item.createTime = dayjs(item.createTime).format("YYYY-MM-DD HH:mm");
					item.estimateDuration = item.estimateDuration + "分钟";
				});
				this.tableData = res.list;
				this.page.totalPage = res.total;
			},

			// 获取教师列表
			async fetchTeacherList() {
				let ss = sessionStorage;
				let params = {
					top_org_id: [ss.orgId],
				};
				const res = await getTeacherList(params);
				console.log("获取教师列表--", res);
				if (!res) return;
				this.teacherList = res.map((item) => {
					return { teacherId: item.user_id, teacherName: item.name };
				});
				localForage.setItem("teacherList", this.teacherList);
			},
			// 作业审核
			async check(scope, state) {
				// console.log(scope);
				let ss = sessionStorage;
				let params = {
					loginPlatformCode: ss.loginPlatformCode,
					platformCode: ss.platformCode,
					usessionid: ss.usessionid,
					homeworkId: scope.row.homeworkId,
					state,
					jobType: this.jobType,
				};
				console.log("作业审核入参--", params);
				const res = await HwAudit(params);
				if (!res) return;
				this.getDataList();
				console.log("审核是否成功--", res);
			},
			// 作业批量审核
			async bulkAudit(state) {
				if (!this.multipleSelection.length) {
					return reqTip.showReqError({}, "请选择需要审核的数据");
				}
				let ids = this.multipleSelection.map((item) => {
					return item.homeworkId;
				});
				console.log("ids--", ids);
				// console.log(scope);
				let ss = sessionStorage;
				let params = {
					loginPlatformCode: ss.loginPlatformCode,
					platformCode: ss.platformCode,
					usessionid: ss.usessionid,
					homeworkIds: ids,
					state,
					jobType: this.jobType,
				};
				const res = await BatchHwAudit(params);
				if (!res) return;
				this.getDataList();
				console.log("审核是否成功--", res);
			},

			searchFun() {
				this.page.pageNum = 1;
				this.getDataList();
			},
			sizeChangeHandle(val) {
				// this.tableData = [];
				this.page.pageSize = val;
				this.getDataList();
			},

			currentChangeHandle(val) {
				// this.tableData = [];
				this.page.pageNum = val;
				this.getDataList();
			},

			goBack() {
				this.$router.go(-1);
				// this.$emit('to-index');
			},
			//批量选中数据列表
			handleSelectionChange(val) {
				this.multipleSelection = val;
				console.log("this.multipleSelection--", this.multipleSelection);
			},
			//按钮禁用
			selectable(row, index) {
				if (row.status == "0") {
					return true;
				}
			},
			// 查看详情
			toDetail(item) {
				item.jobType = this.jobType;
				item.toModify = "";
				if (item.status == 0) item.showCheckArea = true;
				console.log("详情item--", { ...item });
				this.$router.push({
					path: "/task/record/detail",
					// query: { id: item.homeworkId, jobType: this.jobType, showCheckArea: true },
					query: item,
				});
			},
			toIndex_detail() {
				this.detail.show = false;
			},
		},
	};
</script>
<style lang="less" scoped>
	.detail {
		width: 100%;
		padding: 0px 30px 30px 30px;
		.header {
			height: 68px;
			line-height: 80px;
			margin-bottom: 20px;
			border-bottom: 1px solid #eee;
			display: flex;
			justify-content: space-between;
			.span1 {
				font-family: "PingFang SC Bold";
				font-size: 20px;
				color: #000;
				margin-right: 30px;
			}
			.left,
			.right {
				width: 60px;
			}
			.left {
				font-size: 14px;
				color: #8b8b8b;
				cursor: pointer;
			}
		}
		.header-btn {
			display: flex;
			margin-bottom: 20px;
		}
		.hwContent {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			.show-hover {
				cursor: pointer;
			}
			> div:first-child img {
				width: 18px;
				height: 18px;
				margin-top: 6px;
				margin-right: 5px;
			}
			> div:last-child {
				text-align: left;
			}
		}
		::v-deep .el-table thead th.el-table__cell {
			padding: 15 0.5px 0;
			font-weight: normal;
			font-size: 14px;
			color: #7a8da2;
			background: #fafafa;
		}
		::v-deep .el-table tbody td.el-table__cell {
			padding: 18.5px 0;
		}

		::v-deep .search-btn.el-form-item {
			margin-bottom: 24px;
		}
		::v-deep .el-form--inline .el-form-item {
			margin-right: 0;
		}
		::v-deep .el-form .el-input__inner {
			width: 120px;
			height: 32px;
			border-radius: 3px;
			background: #fff;
			border: 1px solid #ddd;
		}

		::v-deep .el-table__header tr th {
			background: #f7f7f7;
			box-shadow: 0px 1px 0px #eaeaea;
		}

		::v-deep .el-date-editor .el-range-separator {
			line-height: 22px;
		}
		::v-deep .el-date-editor .el-range-separator {
			line-height: 22px;
		}
		::v-deep .el-date-editor.el-input,
		.el-date-editor.el-input__inner {
			width: 133px;
		}
		.selectWidth {
			::v-deep .el-input__inner {
				width: 110px;
			}
		}
		.selectWidthTeach {
			::v-deep .el-input__inner {
				width: 90px;
			}
		}
		.selectWidthCheck {
			::v-deep .el-input__inner {
				width: 90px;
			}
		}
		.selectWidthDate {
			::v-deep .el-input__inner {
				width: 100%;
			}
		}

		::v-deep .el-table--border .borderCollapse.el-table__cell {
			border-right: 0;
		}

		.pagination {
			text-align: center;
			margin-top: 30px;
		}

		.green {
			color: #50b173;
		}
		.blue {
			color: #4b83f7;
		}
		.red {
			color: #f74b4b;
		}
	}
</style>
